import { Link, NavLink } from "react-router-dom";
import { Feather } from "lucide-react";

const navItems = [
    { to: "/taubenhimmel", label: "Taubenhimmel" },
    { to: "/himmelsfonds", label: "Himmelsfond" },
    { to: "/vermittlung", label: "Vermittlung" },
];

export default function SiteLayout({ children, transparentNav = false }) {
    return (
        <div className="min-h-screen text-[#f8fafc] flex flex-col">
            <header
                className={`sticky top-0 z-40 ${
                    transparentNav ? "bg-[#040710]/40" : "bg-[#040710]/85"
                } backdrop-blur-xl border-b border-white/5`}
            >
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-2">
                    <Link to="/" className="flex items-center gap-3 group flex-shrink-0" data-testid="nav-logo">
                        <div className="relative w-9 h-9 flex items-center justify-center flex-shrink-0">
                            <div className="absolute inset-0 rounded-full bg-[#f0c674]/15 blur-md group-hover:bg-[#f0c674]/30 transition-colors" />
                            <Feather size={20} className="text-[#f0c674]" strokeWidth={1.5} />
                        </div>
                        <span className="hidden sm:inline font-display text-2xl tracking-tight">Taubenwacht</span>
                    </Link>
                    <nav className="flex items-center gap-0.5 sm:gap-2 overflow-x-auto no-scrollbar">
                        {navItems.map((it) => (
                            <NavLink
                                key={it.to}
                                to={it.to}
                                className={({ isActive }) =>
                                    `px-2.5 sm:px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                                        isActive
                                            ? "text-[#f0c674]"
                                            : "text-[#94a3b8] hover:text-[#f8fafc]"
                                    }`
                                }
                                data-testid={`nav-${it.to.slice(1)}`}
                            >
                                {it.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            </header>

            <main className="flex-1 relative z-10">{children}</main>

            <footer className="border-t border-white/5 mt-32">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                        <div>
                            <div className="flex items-center gap-3 mb-4">
                                <Feather size={18} className="text-[#f0c674]" strokeWidth={1.5} />
                                <span className="font-display text-xl">Taubenwacht</span>
                            </div>
                            <p className="text-[#94a3b8] text-sm leading-relaxed max-w-xs">
                                Ein Ort der Erinnerung, der Hilfe und der zweiten Chance.
                            </p>
                        </div>
                        <div>
                            <div className="label mb-3">Plattform</div>
                            <ul className="space-y-2 text-sm">
                                <li>
                                    <Link to="/taubenhimmel" className="text-[#94a3b8] hover:text-[#f0c674]">
                                        Taubenhimmel
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/himmelsfonds" className="text-[#94a3b8] hover:text-[#f0c674]">
                                        Himmelsfond
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/vermittlung" className="text-[#94a3b8] hover:text-[#f0c674]">
                                        Vermittlung
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div className="label mb-3">Rechtliches</div>
                            <ul className="space-y-2 text-sm">
                                <li>
                                    <Link to="/impressum" className="text-[#94a3b8] hover:text-[#f0c674]" data-testid="footer-impressum">
                                        Impressum
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/datenschutz" className="text-[#94a3b8] hover:text-[#f0c674]" data-testid="footer-datenschutz">
                                        Datenschutz
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/agb" className="text-[#94a3b8] hover:text-[#f0c674]" data-testid="footer-agb">
                                        AGB &amp; Widerruf
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div className="text-[#64748b] text-xs font-mono">© 2026 Taubenwacht</div>
                        <Link
                            to="/admin/login"
                            className="text-[#64748b] hover:text-[#f0c674] text-xs font-mono"
                            data-testid="footer-admin"
                        >
                            Admin
                        </Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}
